module.exports = __webpack_public_path__ + "img/Symbol_5.51dc1ca8.png";